import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, BookOpen, Gift, Star } from 'lucide-react';
export function SolutionIntro() {
  const features = [{
    icon: <BookOpen className="w-6 h-6 text-blue-400" data-id="element-314" />,
    title: 'Tomo 1',
    desc: 'Fonética'
  }, {
    icon: <BookOpen className="w-6 h-6 text-green-400" data-id="element-315" />,
    title: 'Tomo 2',
    desc: 'Día a Día'
  }, {
    icon: <BookOpen className="w-6 h-6 text-orange-400" data-id="element-316" />,
    title: 'Tomo 3',
    desc: 'Emergencias'
  }, {
    icon: <BookOpen className="w-6 h-6 text-red-400" data-id="element-317" />,
    title: 'Tomo 4',
    desc: 'Anti-Estafas'
  }, {
    icon: <Gift className="w-6 h-6 text-purple-400" data-id="element-318" />,
    title: 'Bonos',
    desc: 'x4'
  }, {
    icon: <Star className="w-6 h-6 text-amber-400" data-id="element-319" />,
    title: 'Expert',
    desc: 'Londres'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative" data-id="element-320">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-96 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-321" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-322">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-500/20 text-amber-400 mb-8" data-id="element-323">
          <Trophy className="w-8 h-8" data-id="element-324" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-325">
          PACKVIAJERO™ MEGAPACK INGLATERRA
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-2xl text-amber-400 font-bold mb-6" data-id="element-326">
          4 Tomos + 4 Bonos + Guía Expert
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-slate-300 mb-4 max-w-2xl mx-auto" data-id="element-327">
          Todo lo que necesitás para comunicarte, moverte y protegerte en
          Londres
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-lg text-slate-400 mb-16 font-medium" data-id="element-328">
          140 páginas — Todo resuelto. Sin buscar en Google. Sin improvisar. Sin
          quedarte mudo.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-329">
          {features.map((feat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4 + i * 0.1
        }} className="glass-panel p-6 rounded-2xl flex flex-col items-center justify-center gap-3 hover:bg-slate-800/60 transition-colors" data-id="element-330">
              {feat.icon}
              <div className="text-center" data-id="element-331">
                <div className="font-bold text-white" data-id="element-332">{feat.title}</div>
                <div className="text-sm text-slate-400" data-id="element-333">{feat.desc}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}